module.exports = __webpack_public_path__ + "static/media/foere.b87500f4.mp3";